import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';

import { useNavigate } from 'react-router-dom'
//var dateFormat = require('dateformat');

	

const RenderAgencycsw = () => {

const resturl=sessionStorage.getItem("RESTURL");
let customspremurl='https://customsprem.gov.tc/';
//var boolFetchingSads=false;

const navigate = useNavigate();

window.addEventListener("keypress", function (event) {
 // detect event keys
 if (event.keyCode == 13) {
   //callsadfinder();
   
 }
});


const [modal, setModal] = useState({open:false});
const navWpform = React.useRef();
const [combolocation, setCombolocation] = useState([]);

const [arraycaseworker, setArraycaseworker] = useState([]);
const [arrstartlettercsw, setArrstartlettercsw] = useState([]);
const [combocaseworker, setCombocaseworker] = useState([]);
const [tickedletters, setTickedletters] = useState([]);
const [officeopts, setOfficeopts] = useState([]);
const [startlettercswkrlog, setStartlettercswkrlog] = useState([]);


const [crit, setCrit] = useState({caseworker:"", tc_island:"", assign_action:""});
const [dowait, setDowait] = useState({on:false});


const location = useLocation();


useEffect(() => {

if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if

document.title =   "Start Letter Case-workers";	

getwpformoptions();
	//qrylabor();
 },[]);


useEffect(() => {

if (officeopts.length>0 && combocaseworker.length==0)
	getallcaseworkers();

 },[JSON.stringify(officeopts)]);


useEffect(() => {

if (arraycaseworker.length>0 && arrstartlettercsw.length==0)
	getarrstartlettercsw();

 },[JSON.stringify(arraycaseworker)]);
 
 
useEffect(() => {

if (arraycaseworker.length<1)
	return;

if (arrstartlettercsw.length<1){
	getarrstartlettercsw();
	}//end if


 },[JSON.stringify(arraycaseworker)]);



useEffect(() => {

if (crit.tc_island!="" && combocaseworker.length==0)
	writecombocaseworkers();

 },[crit.assign_action]);


useEffect(() => {

setCrit((prev)=>{
	return {...prev, caseworker:""}
	});

if (crit.tc_island!="" && arraycaseworker.length>1){
	writecombocaseworkers();
	getarrstartlettercsw();
	}//end if

 },[crit.tc_island]);


useEffect(() => {

if (startlettercswkrlog.length>0){
	window.scrollTo(0, document.body.scrollHeight);
	}//end if

 },[JSON.stringify(startlettercswkrlog)]);
 


async function getwpformoptions(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( )
  };		

await  fetch(resturl+'rarwpform/getwpformoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwpformoptions(res) )
      .catch(err => console.log(err));

}//end func

function aftergetwpformoptions(res){
console.log("aftergetwpformoptions");
if (!res.length)
	return;

let templocation=[] ;

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='immigoffice' ){
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
		if (opt==sessionStorage.getItem("TC_ISLAND"))
			setCrit((prev)=>{
				return {...prev, tc_island:opt}
			});
		
		}//end if
		
	
	});//end map
	
console.log("templocation.length: "+templocation.length);
	
setOfficeopts(templocation);

}//end func


async function getarrstartlettercsw(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {tc_island:crit.tc_island})
  };		

setArrstartlettercsw([]);

  await fetch(resturl+'rarwpform/getarrstartlettercsw',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetarrstartlettercsw(res) )
      .catch(err => console.log(err));

}//end func

function aftergetarrstartlettercsw(res){

let temp=[];
if (!res.length)
	return;

res.map((col, index) => {
	temp.push({
		ROW_NUM: col['ROW_NUM']
		, COL_NUM: col['COL_NUM']
		, START_LETTER: col['START_LETTER']
		, CASE_WORKER: col['CASE_WORKER']
		, DEPUTY: col['DEPUTY']
		, MODIFY_DATE: col['MODIFY_DATE']
		, MODIFY_USER: col['MODIFY_USER']
		, NEXT_WPT_APP_ID: col['NEXT_WPT_APP_ID']
		});
	
	});//end map
setArrstartlettercsw(temp);

}//end func



async function getallcaseworkers(){
console.log("getallcaseworkers");

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {})
  };		

setCombocaseworker([]);

  await fetch(resturl+'rarwpform/getallcaseworkers',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetallcaseworkers(res) )
      .catch(err => console.log(err));

}//end func

function aftergetallcaseworkers(res){

if (!res.length)
	return;

let temp=[];

res.map((col, index) => {
	temp.push({
		USERNAME:col['USERNAME']
		,FULLNAME:col['FULLNAME']
		,GNRL_CUSTOMERS:col['GNRL_CUSTOMERS']
		,TC_ISLAND:col['TC_ISLAND']
	});
	
	});//end map

setArraycaseworker(temp);
//TC_ISLAND, PROCESS_AREA
}//end func


function writecombocaseworkers(){
console.log("writecombocaseworkers");
let temp=[];

arraycaseworker.map((col, index) => {
	
	if (col['GNRL_CUSTOMERS']=="1" && col['TC_ISLAND']==crit.tc_island)
		temp.push(<option value={col['USERNAME']} >{col['FULLNAME']}</option>);
	
	});//end map

setCombocaseworker(temp);
//TC_ISLAND, PROCESS_AREA
}//end func




function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 2500);
}//end func



function toggleModalsm() {
if (!document.querySelector(".modalsm"))
	return false;

if (!document.getElementById("btnupdate").classList.contains("hidden"))
	document.getElementById("btnupdate").classList.add("hidden");
		
const modalsm = document.querySelector(".modalsm");
	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");
const isopen=modalsm.classList.contains("show-modalsm");
setModal((prev)=>{return {...prev, open:isopen};})

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func



function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");

if (event.target === modalsm) 
	toggleModalsm();
    
}//end func



async function getstartlettercswkrlog(e){
e.preventDefault();

const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	, letters: tickedletters
	, caseworker: crit.caseworker
	, tc_island: crit.tc_island
	, assign_action: crit.assign_action
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
		
  await fetch(resturl+'rarwpform/getstartlettercswkrlog',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetstartlettercswkrlog(res) )
      .catch(err => console.log(err));

}//end func


function aftergetstartlettercswkrlog(res){

let temp = [];

res.map((col, index) => {
	const key='tr_'+index;

	temp.push(<tr key={key} >
	<td align='right' >{index+1}&nbsp;</td>
	<td align='left' >{col['WPT_APP_OFFICE']}</td>
	<td align='center' >{col['START_LETTER']}</td>
	<td align='left' >{col['CASE_WORKER_WAS']}</td>
	<td align='left' >{col['CASE_WORKER']}</td>
	<td align='left' >{col['DEPUTY_WAS']}</td>
	<td align='left' >{col['DEPUTY']}</td>
	<td align='center' >{col['LOG_DATE1']}</td>
	<td align='center' >{col['USERNAME']}</td>
	</tr>);
	
	});
	
setStartlettercswkrlog(temp);
	
}//end func

async function submitform1(e){
e.preventDefault();

const params={
	USERNAME:sessionStorage.getItem("USERNAME")
	, letters: tickedletters
	, caseworker: crit.caseworker
	, tc_island: crit.tc_island
	, assign_action: crit.assign_action
	};

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		
		
  await fetch(resturl+'rarwpform/updatestartlettercsw',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateagencycsw(res) )
      .catch(err => console.log(err));

}//end func

function afterupdateagencycsw(res){
const update_count=res.length?(res[0].UPDATE_COUNT??0):0;	
showsnackbar("# of records updated: "+update_count);
getarrstartlettercsw();

const td_action=document.getElementById("td_action");
if (!td_action.classList.contains("hidden"))
	td_action.classList.add("hidden");

const btnupdate=document.getElementById("btnupdate");
if (!btnupdate.classList.contains("hidden"))
	btnupdate.classList.add("hidden");

const combocaseworker=document.getElementById("combocaseworker");
if (!combocaseworker.classList.contains("hidden"))
	combocaseworker.classList.add("hidden");



}//end func
	



function handleChange(e){
const {name, value}	=e.target;

setCrit((prev)=>{
	return {...prev, [name]:value}
	});


}//end func

function tickTblletters(e, elemName){
	const len=document.getElementsByName(elemName).length;
	for (var i=0; i<len; i++)
		document.getElementsByName(elemName)[i].checked=e.target.checked;
	
	countTickedLetters();
}//end func

function countTickedLetters(){
	/* 
	start by hiding the button and untick rdactions 
	*/
	var len=document.getElementsByName("rdaction").length;
	for (var i=0; i<len; i++)
		document.getElementsByName("rdaction")[i].checked=false;

	const combocaseworker=document.getElementById("combocaseworker");
	if (!combocaseworker.classList.contains("hidden"))
		combocaseworker.classList.add("hidden");
	
	const btnupdate=document.getElementById("btnupdate");
	if (!btnupdate.classList.contains("hidden"))
		btnupdate.classList.add("hidden");
	
	setCrit((prev)=>{
		return {...prev, caseworker:""}
		});
	
	let checkedCount=0;
	
	len=document.getElementsByName("checkboxname[]").length;
	let temp_tickedletters=[];
	
	for (var i=0; i<len; i++){
		const checkboxname=document.getElementsByName("checkboxname[]")[i].value;
		if (document.getElementsByName(checkboxname)){
			const sublen=document.getElementsByName(checkboxname).length;
			console.log("checkboxname: "+checkboxname);
			console.log("sublen: "+sublen);
			for (var s=0; s<sublen; s++){
				if (document.getElementsByName(checkboxname)[s].checked){
					checkedCount++;
					temp_tickedletters.push(document.getElementsByName(checkboxname)[s].value);
					}
				}//end for
			}//end if
		}//end for

setTickedletters(temp_tickedletters);

console.log("checkedCount: "+checkedCount);
const td_action=document.getElementById("td_action");
const btn_his_log=document.getElementById("btn_his_log");
if (checkedCount==0){
	if (!td_action.classList.contains("hidden"))
		td_action.classList.add("hidden");
	if (!btn_his_log.classList.contains("hidden"))
		btn_his_log.classList.add("hidden");
	}//end if
else{
	if (td_action.classList.contains("hidden"))
		td_action.classList.remove("hidden");
	if (btn_his_log.classList.contains("hidden"))
		btn_his_log.classList.remove("hidden");
	}	

}//end func

function clickrdaction(e){

const combocaseworker=document.getElementById("combocaseworker");
if (combocaseworker.classList.contains("hidden"))
	combocaseworker.classList.remove("hidden");

setCrit((prev)=>{
	return {...prev, assign_action:e.target.value}
	});
	
}//end func

function changeCombocaseworker(e){

const btnupdate=document.getElementById("btnupdate");

if (e.target.value==""){
	if (!btnupdate.classList.contains("hidden"))
		btnupdate.classList.add("hidden");
	}//end if
else{
	if (btnupdate.classList.contains("hidden"))
		btnupdate.classList.remove("hidden");
	}

setCrit((prev)=>{
	return {...prev, caseworker:e.target.value}
	});

}//end func

function tblstartlettercsw(starts, ends){

let htmrows=[];
let  checkboxId="";
const checkboxName="checkboxName"+"-"+starts+"-"+ends;

arrstartlettercsw.map((col, index) => {
	const trkey='tr_'+starts+'-'+ends+'-'+index;
	
	//if (col['ROW_NUM']==rowNum && col['COL_NUM']==colNum){
	if (col['START_LETTER']>=starts && col['START_LETTER']<=ends){
		//console.log("inside if: "+starts+"-"+ends+" htmrows.length: "+htmrows.length);
		const START_LETTER=col['START_LETTER'];
		 checkboxId=trkey;
		 
		const htmrow=<tr key={trkey} >
					<td align='center' ><input type='checkbox' name={checkboxName} value={START_LETTER} id={checkboxId} onClick={(e)=>{countTickedLetters();}} /><label htmlFor={checkboxId} className="hand" >{START_LETTER}</label></td>
					<td align='left' >{col['CASE_WORKER']}</td>
					<td align='left' >{col['DEPUTY']}</td>
					<td align='center' >{col['MODIFY_DATE']}</td>
					<td align='left' >{col['MODIFY_USER']}</td>
					<td align='left' >{col['NEXT_WPT_APP']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		}//end if
	});	
	
//console.log(rowNum+"-"+colNum+" htmrows.length: "+htmrows.length);
 checkboxId="checkboxId"+"-"+starts+"-"+ends;
htmrows=[<table align="center" className="customers" >
		<thead>
		<tr>
		<th align="center" ><input type='checkbox' name={checkboxId} onClick={(e)=>{tickTblletters(e, checkboxName);}} id={checkboxId} /><label htmlFor={checkboxId} className="hand" >Letter</label></th>
		<th align="left" >Case<br/>Worker</th>
		<th align="left" >Supervisor<br/>or Deputy</th>
		<th align="center" >Modify<br/>Date</th>
		<th align="left" >Modify<br/>User</th>
		<th align="left" >Next<br/>Application</th>
		</tr>
		</thead>
		<tbody>
		{htmrows}
		</tbody>
		</table>,<input name='checkboxname[]' value={checkboxName} type='hidden' />];	
return htmrows;
}//end func
	

  return (
    <>
	<p align="center" className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >
	Assign Case Workers by Agency/Employer Name
	</p>
	<div align="center" ><a href="#" onClick={(e)=>{e.preventDefault();navigate("/wpapps");}} className="nodecor" ><img src="img/return.png" border="0" /> return to table of applications</a></div>
	
	<form id="form1" method="POST" onSubmit={(e)=>{submitform1(e);}} >
	<table align='center' border="0" style={{width:"85%"}} >
	<tbody>
	<tr valign="top" >
		<td align="center" >Location: <select name="tc_island" value={crit.tc_island} onChange={(e)=>{handleChange(e);}} >{officeopts}</select></td>
		<td align="left" id='td_action' className='hidden' style={{paddingLeft:"18px"}} >
			<input type='radio' name='rdaction' id='rdcsw' value="csw" onClick={(e)=>{clickrdaction(e);}} /><label htmlFor='rdcsw' className='hand' >assign case-worker</label>
			<br/><input type='radio' name='rdaction' id='rddep' value="dep" onClick={(e)=>{clickrdaction(e);}} /><label htmlFor='rddep' className='hand' >assign deputy</label>
		</td>
		<td align="center" >
			<select id='combocaseworker'value={crit.caseworker} className='hidden' onChange={(e)=>{changeCombocaseworker(e);}} >
			<option value='' >*** select case-worker ***</option>
			{combocaseworker}
			</select>
		</td>
		<td align="center" ><button id='btnupdate' className='button hidden' >update case-worker for selected letters</button></td>
	</tr>
	</tbody>
	</table>
	</form>

	{
	arrstartlettercsw.length>0 && <>
	<table align='center' border="0" style={{width:"98%"}} id="tblmain" >
	<tbody>
	<tr valign="top" >
		<td align="center" >{tblstartlettercsw('A','C')}</td>
		<td align="center" >{tblstartlettercsw('D','F')}</td>
		<td align="center" >{tblstartlettercsw('G','I')}</td>
	</tr>
	<tr valign="top" >
		<td align="center" >{tblstartlettercsw('J','L')}</td>
		<td align="center" >{tblstartlettercsw('M','O')}</td>
		<td align="center" >{tblstartlettercsw('P','R')}</td>
	</tr>
	<tr valign="top" >
		<td align="center" >{tblstartlettercsw('S','U')}</td>
		<td align="center" >{tblstartlettercsw('V','X')}</td>
		<td align="center" >{tblstartlettercsw('Y','Z')}</td>
	</tr>
	</tbody>
	</table>
	<p align="center">
	<button className="button hidden" id="btn_his_log" onClick={(e)=>{getstartlettercswkrlog(e);}} >show history log</button>
	</p>
	</>
	}
	
	{
	startlettercswkrlog.length>0 && <>
	<div align='center' className="Acme" style={{marginBottom:"6px", marginTop:"9px", color:"brown",fontSize:"24px"}} >History Log of Case Workers by Agency/Employer Name</div>
	<table align='center' border="0" className="customers" style={{width:"80%", marginBottom:"20px"}} >
	<thead>
	<tr>
	<th align="right" >#</th>
	<th align="left" >Location</th>
	<th align="center" >Letter</th>
	<th align="left" >Case Worker<br/>Before Update</th>
	<th align="left" >Case Worker<br/>After Update</th>
	<th align="left" >Deputy<br/>Before Update</th>
	<th align="left" >Deputy<br/>After Update</th>
	<th align="center" >Updated Date</th>
	<th align="center" >Username</th>
	</tr>
	</thead>
	<tbody>
	{startlettercswkrlog}
	</tbody>
	</table>
	</>
	}


<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button"  >&times;</span>
        <div align='center' id='modalsmtext' >
			
			<table align='center'>
			<tbody>

			<tr>
			<td align='right' >: </td>
			<td align='left' ></td>
			</tr>	
			
			</tbody>
			</table>
			
			
		</div>
    </div>
</div>
<div id="snackbar">&nbsp;</div>


    </>
  );
  


};


export default RenderAgencycsw;